import { AxiosResponse } from 'axios';

import { HttpClient } from 'api/HttpClient';

import { ApplicationDto } from './ApplicationApi';

export interface StartKbaRequest {
  borrowerType: string;
  applicationId: string;
}

export interface KbaAnswers {
  questionType: number;
  text: string;
}

export interface VerifyKbaAnswerRequest {
  borrowerType: string;
  applicationId: string;
  answers: KbaAnswers[];
}

export interface KbaQuestion {
  answers: string[];
  text: string;
  questionType: number;
}

export interface StartKbaResponse {
  questions: KbaQuestion[];
  timestamp?: number | null;
}

export interface GetStartingKbaTimestampResponse {
  isStart: boolean;
  timestamp?: number | null;
}

export default class KbaApi extends HttpClient {
  public constructor() {
    super(process.env.REACT_APP_API_URL + '/identity/kba' || '');
  }

  public async startKba(body: StartKbaRequest) {
    return this.instance.post('/start', body).then((response: AxiosResponse<StartKbaResponse>) => response.data);
  }

  public async verifyKbaAnswers(body: VerifyKbaAnswerRequest): Promise<ApplicationDto> {
    return this.instance.post('/verify', body).then((response: AxiosResponse<any>) => response.data);
  }

  public async getStartingTimestamp(body: StartKbaRequest): Promise<GetStartingKbaTimestampResponse> {
    return this.instance.post('/getTimestamp', body).then((response: AxiosResponse<any>) => response.data);
  }
}

export const kbaApi = new KbaApi();
